import React from "react";
import Accordion from "../../../common/accordion";
import { useAppSelector } from "../../../../store/hooks/StoreHooks";
import useCollapseFacade from "../../../../facade/collapse.Facade";
import { LABELS } from "../../../../constants/labels/help.labels";

const Cable: React.FC = () => {
    const {
        surfaceVoltCollapse,
        cableCleavoltCollapse,
    } = useAppSelector((state) => state?.collapse);

    const {
        updateCableCleavoltCollapse,
        updateSurfaceVoltCollapse,
    } = useCollapseFacade();

    const handleCollapseChange = (key: boolean, name: string) => {
        if (name === "CableCleavolt") updateCableCleavoltCollapse(key);
        else if (name === "SurfaceVolt") updateSurfaceVoltCollapse(key);
    };

    return (
        <div className="flex flex-col justify-center item-center w-full h-full gap-[16px] text-white">
            <Accordion
                title={LABELS?.cableClearance}
                id={'CableCleavolt'}
                isOpen={!cableCleavoltCollapse}
                onToggle={() =>
                    handleCollapseChange(!cableCleavoltCollapse, "CableCleavolt")
                }
                content={
                    <div className="flex justify-center items-center bg-darkcolor-800 p-[16px] w-full rounded-br-lg rounded-bl-lg">
                        <div className='pad-all w-full bg-darkcolor-700 border-[1px] border-darkcolor-400 rounded-lg'>
                            <table className="table table-striped table-bordered dtr-inline">
                                <colgroup>
                                    <col style={{ width: "10%" }} />
                                    <col style={{ width: "40%", borderRight: "1px solid #4a5463" }} />
                                    <col style={{ width: "10%" }} />
                                    <col style={{ width: "40%" }} />
                                </colgroup>
                                <tr className="border-b-[1px] border-darkcolor-400 align-center text-[14px] font-normal">
                                    <th className="px-[24px] py-[16px] align-center font-normal">Casing-Tubing-Cable</th>
                                    <td className="col-4 px-[24px] py-[16px]">
                                        <div className="pb-4 secondary">
                                            Draw chart on casing coordinates, tubing coordinates & cable coordinates
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">Tubing coordinates :</p>
                                            <p className="secondary-text">
                                                To fetch coordinates it will loop through 200 iteration<br />
                                            </p>
                                            <p className="secondary">if iteration equals to 1 :</p>
                                            <p className="secondary-text">
                                                TubingXvalue = TubingStart1 - TubingcouplingOD / 2<br />
                                                TubingYvalue = ((TubingcouplingOD / 2)^2 - (TubingXvalue -
                                                TubingStart1)^2)^0.5
                                            </p>
                                            <p className="secondary"> if iteration not equals to 1 & iteration is less than
                                                101 :</p>
                                            <p className="secondary-text">
                                                TubingXvalue = TubingXvalue + TubingStart2<br />
                                                TubingYvalue = ((TubingcouplingOD / 2) ^ 2 - (TubingXvalue - TubingStart1) ^
                                                2)^0.5
                                            </p>
                                            <p className="secondary"> if iteration equal to 101 :</p>
                                            <p className="secondary-text">
                                                TubingXvalue = TubingXvalue + TubingStart2<br />
                                                TubingYvalue = (Absolute(TubingcouplingOD / 2) ^ 2 - (TubingXvalue -
                                                TubingStart1) ^ 2)^0.5
                                            </p>
                                            <p className="secondary"> Otherwise :</p>
                                            <p className="secondary-text">
                                                TubingXvalue = TubingXvalue - TubingStart2<br />
                                                TubingYvalue = -((TubingcouplingOD / 2) ^ 2 - (TubingXvalue - TubingStart1)
                                                ^ 2) ^ 0.5
                                            </p>
                                            <p className="secondary">TubingStart1 :</p>
                                            <p className="secondary-text">
                                                (-casingID/2 + TubingcouplingOD / 2)
                                            </p>
                                            <p className="secondary">TubingStart2 :</p>
                                            <p className="secondary-text">
                                                TubingcouplingOD / 100
                                            </p>
                                            <p className="secondary">TubingcouplingOD :</p>
                                            <p className="secondary-text">
                                                Selected tubing CouplingOD from ESP catalog (DR_TubingSize table in
                                                database)
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">Cable coordinates :</p>
                                            <p className="secondary-text">
                                                To fetch coordinates it will loop through 200 iteration<br />
                                            </p>
                                            <p className="secondary">if iteration equals to 1 :</p>
                                            <p className="secondary-text">
                                                CableXvalue = TubingStart1 + TubingcouplingOD / 2<br />
                                                CableYvalue = 0
                                            </p>
                                            <p className="secondary">if iteration equals to 2 :</p>
                                            <p className="secondary-text">
                                                CableXvalue = TubingStart1 + TubingcouplingOD / 2<br />
                                                CableYvalue = ((CableStart2 / 2)^2 - (CableXvalue - CableStart3)^2)^0.5 +
                                                (CableDimB /2 - CableDimA / 2)
                                            </p>
                                            <p className="secondary">
                                                if iteration not equals to 1and 2 & iteration is less than 102 :</p>
                                            <p className="secondary-text">
                                                CableXvalue = CableXvalue + CableStart1<br />
                                                CableYvalue = ((CableStart2 / 2) ^ 2 - (CableXvalue - CableStart3) ^ 2) ^
                                                0.5 + (CableDimB / 2 - CableDimA / 2)
                                            </p>
                                            <p className="secondary"> if iteration equal to 102 :</p>
                                            <p className="secondary-text">
                                                CableXvalue = CableXvalue<br />
                                                CableYvalue = (CableYvalue - CableDimB + CableDimA)
                                            </p>
                                            <p className="secondary">
                                                if iteration is greater than 102 & iteration is not equal to 201 :
                                            </p>
                                            <p className="secondary-text">
                                                CableXvalue = CableXvalue - CableStart1<br />
                                                CableYvalue = -((CableStart2 / 2) ^ 2 - (CableXvalue - CableStart3) ^ 2) ^
                                                0.5 + (CableDimB / 2 - CableDimA / 2)
                                            </p>
                                            <p className="secondary">
                                                if iteration is equal to 201 :
                                            </p>
                                            <p className="secondary-text">
                                                CableXvalue = CableXvalue<br />
                                                CableYvalue = 0
                                            </p>

                                            <p className="secondary"> CableStart1 :</p>
                                            <p className="secondary-text">
                                                (CableDimA/100)
                                            </p>
                                            <p className="secondary">CableStart2 :</p>
                                            <p className="secondary-text">
                                                CableDimA
                                            </p>
                                            <p className="secondary">CableStart3 :</p>
                                            <p className="secondary-text">
                                                (TubingStart1 + TubingcouplingOD / 2 + CableDimA/2)
                                            </p>
                                            <p className="secondary">CableDimA & CableDimB :</p>
                                            <p className="secondary-text">
                                                Selected CableDimensionA,CableDimensionB from ESP catalog (Dr_Cables table
                                                in database)
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">Casing coordinates :</p>
                                            <p className="secondary-text">
                                                Please refer to the last row of this table<br />
                                            </p>
                                        </div>
                                    </td>
                                    <th className="px-[24px] py-[16px] align-center font-normal">Casing-Pump-Motor lead</th>
                                    <td className="col-4 px-[24px] py-[16px]">
                                        <div className="pb-4 secondary">
                                            Draw chart on casing coordinates, pump coordinates & motor lead1 coordinates
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">Pump coordinates :</p>
                                            <p className="secondary-text">
                                                To fetch coordinates it will loop through 200 iteration<br />
                                            </p>
                                            <p className="secondary">if iteration equals to 1 :</p>
                                            <p className="secondary-text">
                                                PumpXvalue = (double)(Pumpstart1 - PumpOD / (double)2)<br />
                                                PumpYvalue = ((PumpOD/2)^2 - (PumpXvalue - Pumpstart1)^2)^0.5
                                            </p>
                                            <p className="secondary"> if iteration not equals to 1 & iteration is less than
                                                101 :</p>
                                            <p className="secondary-text">
                                                PumpXvalue = PumpXvalue + PumpStart2<br />
                                                PumpYvalue = ((PumpOD / 2) ^ 2 - (PumpXvalue - Pumpstart1) ^ 2) ^ 0.5
                                            </p>
                                            <p className="secondary"> if iteration equal to 101 :</p>
                                            <p className="secondary-text">
                                                PumpXvalue = PumpXvalue + PumpStart2<br />
                                                PumpYvalue = (Absolute(PumpOD / 2) ^ 2 - (PumpXvalue - Pumpstart1) ^ 2) ^ 0.
                                            </p>
                                            <p className="secondary"> Otherwise :</p>
                                            <p className="secondary-text">
                                                PumpXvalue = PumpXvalue - PumpStart2<br />
                                                PumpYvalue = -((PumpOD / 2) ^ 2 - (PumpXvalue - Pumpstart1) ^ 2) ^ 0.5
                                            </p>

                                            <p className="secondary">Pumpstart1 :</p>
                                            <p className="secondary-text">
                                                (-casingID / 2 + PumpOD/2);
                                            </p>
                                            <p className="secondary">PumpStart2 :</p>
                                            <p className="secondary-text">
                                                (PumpOD/100);
                                            </p>
                                            <p className="secondary">PumpOD :</p>
                                            <p className="secondary-text">
                                                Selected PumpOD from ESP catalog (DR_Pumps table in database)
                                            </p>
                                        </div><br />
                                        <div className="pb-4">
                                            <p className="secondary">Motor lead1 coordinates :</p>
                                            <p className="secondary-text">
                                                To fetch coordinates it will loop through 200 iteration<br />
                                            </p>
                                            <p className="secondary">if iteration equals to 1 or 2 :</p>
                                            <p className="secondary-text">
                                                LeadXvalue = (Pumpstart1 + PumpOD / 2)<br />
                                                LeadYvalue = 0
                                            </p>
                                            <p className="secondary">
                                                iteration is less than 102 & iteration not equal to 1 & 2 :</p>
                                            <p className="secondary-text">
                                                LeadXvalue = LeadXvalue + LeadStart1<br />
                                                LeadYvalue = ((LeadStart2 / 2)^2 - (LeadXvalue - LeadStart3)^2)^0.5 +
                                                (LeadDimB/2 - LeadDimA/2)
                                            </p>
                                            <p className="secondary">
                                                if equal to 102 :</p>
                                            <p className="secondary-text">
                                                LeadXvalue = LeadXvalue<br />
                                                LeadYvalue = (LeadYvalue - LeadDimB + LeadDimA)
                                            </p>
                                            <p className="secondary">
                                                iteration greater than 102 & iteration not equal to 201 :</p>
                                            <p className="secondary-text">
                                                LeadXvalue = LeadXvalue - LeadStart1<br />
                                                LeadYvalue = -((LeadStart2 / 2)^2 - (LeadXvalue - LeadStart3)^2)^0.5 -
                                                (LeadDimB / 2 - LeadDimA / 2)
                                            </p>
                                            <p className="secondary">
                                                if iteration equal to 201 :
                                            </p>
                                            <p className="secondary-text">
                                                LeadXvalue = LeadXvalue<br />
                                                LeadYvalue = 0
                                            </p>
                                            <p className="secondary">
                                                LeadStart1 :
                                            </p>
                                            <p className="secondary-text">
                                                (LeadDimA / 100);
                                            </p>

                                            <p className="secondary"> LeadStart3 :</p>
                                            <p className="secondary-text">
                                                (Pumpstart1 + PumpOD/2 + LeadDimA/2);
                                            </p>
                                            <p className="secondary">LeadStart2 :</p>
                                            <p className="secondary-text">
                                                LeadDimA
                                            </p>
                                            <p className="secondary">LeadDimA & LeadDimB :</p>
                                            <p className="secondary-text">
                                                Selected LeadDimA, LeadDimB from ESP catalog (DR_MotorLeads table in
                                                database)
                                            </p>
                                        </div>
                                        <div className="">
                                            <p className="secondary">Casing coordinates :</p>
                                            <p className="secondary-text">
                                                Please refer to the last row of this table<br />
                                            </p>
                                        </div>
                                    </td>
                                </tr>
                                <tr className="border-b-[1px] border-darkcolor-400 align-center text-[14px] font-normal">
                                    <th className="px-[24px] py-[16px] align-center font-normal">Casing-Seal-Motor lead</th>
                                    <td className="col-4 px-[24px] py-[16px]">
                                        <div className="pb-4 secondary">
                                            Draw chart on casing coordinates, protector coordinates & motor lead2 coordinates
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">Protector coordinates :</p>
                                            <p className="secondary-text">
                                                To fetch coordinates it will loop through 200 iteration<br />
                                            </p>
                                            <p className="secondary">if iteration equals to 1 :</p>
                                            <p className="secondary-text">
                                                ProtectorXvalue = (ProtectorStart1 - ProtectorOD / 2)<br />
                                                ProtectorYvalue = ((ProtectorOD / 2)^ 2 - (ProtectorXvalue -
                                                ProtectorStart1)^2)^0.5
                                            </p>
                                            <p className="secondary"> if iteration not equals to 1 & iteration is less than
                                                101 :</p>
                                            <p className="secondary-text">
                                                ProtectorXvalue = ProtectorXvalue + ProtectorStart2<br />
                                                ProtectorYvalue = ((ProtectorOD / 2) ^ 2 - (ProtectorXvalue -
                                                ProtectorStart1) ^ 2) ^ 0.5
                                            </p>
                                            <p className="secondary"> if iteration equal to 101 :</p>
                                            <p className="secondary-text">
                                                ProtectorXvalue = ProtectorXvalue + ProtectorStart2<br />
                                                ProtectorYvalue = (Absolute(ProtectorOD / 2) ^ 2 - (ProtectorXvalue -
                                                ProtectorStart1) ^ 2) ^ 0.5
                                            </p>
                                            <p className="secondary"> Otherwise :</p>
                                            <p className="secondary-text">
                                                ProtectorXvalue = ProtectorXvalue - ProtectorStart2<br />
                                                ProtectorYvalue = -((ProtectorOD / 2) ^ 2 - (ProtectorXvalue -
                                                ProtectorStart1) ^ 2) ^ 0.5
                                            </p>
                                            <p className="secondary"> ProtectorStart1 :</p>
                                            <p className="secondary-text">
                                                (-casingID / 2 + ProtectorOD / 2)
                                            </p>
                                            <p className="secondary">ProtectorStart2 :</p>
                                            <p className="secondary-text">
                                                (ProtectorOD / 100)
                                            </p>
                                            <p className="secondary">ProtectorOD :</p>
                                            <p className="secondary-text">
                                                Selected ProtectorOD from ESP catalog (DR_Protector table in database)
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">Motor lead2 coordinates :</p>
                                            <p className="secondary-text">
                                                To fetch coordinates it will loop through 200 iteration<br />
                                            </p>
                                            <p className="secondary">if iteration equals to 1 or 2 :</p>
                                            <p className="secondary-text">
                                                LeadXvalue = (ProtectorStart1 + ProtectorOD / 2)<br />
                                                LeadYvalue = 0
                                            </p>
                                            <p className="secondary">iteration less than 102 & iteration not equals to 1 & 2
                                                :</p>
                                            <p className="secondary-text">
                                                LeadXvalue = LeadXvalue + LeadStart1<br />
                                                LeadYvalue = ((LeadStart2 / 2)^2 - (LeadXvalue - LeadStart3)^2)^0.5 +
                                                (LeadDimB / 2 - LeadDimA / 2)
                                            </p>
                                            <p className="secondary">
                                                if iteration equal to 102 :</p>
                                            <p className="secondary-text">
                                                LeadXvalue = LeadXvalue<br />
                                                LeadYvalue = (LeadYvalue - LeadDimB + LeadDimA)
                                            </p>
                                            <p className="secondary"> if iteration greater than 102 & iteration MOT equal to
                                                201 :</p>
                                            <p className="secondary-text">
                                                LeadXvalue = LeadXvalue - LeadStart1<br />
                                                LeadYvalue = -((LeadStart2 / 2) ^ 2 - (LeadXvalue - LeadStart3) ^ 2) ^ 0.5 +
                                                (LeadDimB / 2 - LeadDimA / 2)
                                            </p>
                                            <p className="secondary">
                                                if iteration equal to 201 :
                                            </p>
                                            <p className="secondary-text">
                                                LeadXvalue = LeadXvalue<br />
                                                LeadYvalue = 0
                                            </p>
                                            <p className="secondary">
                                                if iteration is equal to 201 :
                                            </p>
                                            <p className="secondary-text">
                                                CableXvalue = CableXvalue<br />
                                                CableYvalue = 0
                                            </p>

                                            <p className="secondary"> LeadStart1 :</p>
                                            <p className="secondary-text">
                                                (LeadDimA/100)
                                            </p>
                                            <p className="secondary">LeadStart2 :</p>
                                            <p className="secondary-text">
                                                LeadDimA
                                            </p>
                                            <p className="secondary">LeadStart3 :</p>
                                            <p className="secondary-text">
                                                (ProtectorStart1 + ProtectorOD / 2 + LeadDimA / 2)
                                            </p>
                                            <p className="secondary">ProtectorOD :</p>
                                            <p className="secondary-text">
                                                Selected ProtectorOD from ESP catalog (DR_Protector table in database)
                                            </p>
                                            <p className="secondary">ProtectorStart1 :</p>
                                            <p className="secondary-text">
                                                (-casingID / 2 + ProtectorOD / 2)
                                            </p>
                                            <p className="secondary">LeadDimA & LeadDimB :</p>
                                            <p className="secondary-text">
                                                Selected LeadDimA & LeadDimB from ESP catalog (DR_MotorLeads table in
                                                database)
                                            </p>
                                        </div>
                                        <div className="">
                                            <p className="secondary">Casing coordinates :</p>
                                            <p className="secondary-text">
                                                Please refer to the last row of this table<br />
                                            </p>

                                        </div>
                                    </td>
                                    <th className="px-[24px] py-[16px] align-center font-normal">Casing-Motor</th>
                                    <td className="col-4 px-[24px] py-[16px]">
                                        <div className="pb-4 secondary">
                                            Draw chart on casing coordinates & motor coordinates
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">Motor coordinates :</p>
                                            <p className="secondary-text">
                                                To fetch coordinates it will loop through 200 iteration<br />
                                            </p>
                                            <p className="secondary">if iteration equals to 1 :</p>
                                            <p className="secondary-text">
                                                MotorXvalue = (double)(MotorStart1 - MotorOD / (double)2)<br />
                                                MotorYvalue = ((MotorOD / 2)^2 - (MotorXvalue - MotorStart1)^2)^0.5
                                            </p>
                                            <p className="secondary"> if iteration not equals to 1 & iteration is less than
                                                101 :</p>
                                            <p className="secondary-text">
                                                MotorXvalue = MotorXvalue + MotorStart2<br />
                                                MotorYvalue = ((MotorOD / 2) ^ 2 - (MotorXvalue - MotorStart1) ^ 2) ^ 0.5
                                            </p>
                                            <p className="secondary"> if iteration equal to 101 :</p>
                                            <p className="secondary-text">
                                                MotorXvalue = MotorXvalue + MotorStart2<br />
                                                MotorYvalue = (Absolute(MotorOD / 2) ^ 2 - (MotorXvalue - MotorStart1) ^ 2)
                                                ^ 0.5
                                            </p>
                                            <p className="secondary"> Otherwise :</p>
                                            <p className="secondary-text">
                                                MotorXvalue = MotorXvalue - MotorStart2<br />
                                                MotorYvalue = -((MotorOD / 2) ^ 2 - (MotorXvalue - MotorStart1) ^ 2) ^ 0.5
                                            </p>
                                            <p className="secondary">MotorStart1 :</p>
                                            <p className="secondary-text">
                                                (-casingID / 2 + MotorOD / 2)
                                            </p>
                                            <p className="secondary">MotorStart2 :</p>
                                            <p className="secondary-text">
                                                (MotorOD / 100)
                                            </p>
                                            <p className="secondary">MotorOD :</p>
                                            <p className="secondary-text">
                                                Selected MotorOD from ESP catalog (DR_Motor table in database)
                                            </p>
                                        </div>
                                        <div className="">
                                            <p className="secondary">Casing coordinates :</p>
                                            <p className="secondary-text">
                                                Please refer to the last row of this table<br />
                                            </p>

                                        </div>
                                    </td>
                                </tr>
                                <tr className="align-center text-[14px] font-normal">
                                    <th className="px-[24px] py-[16px] align-center font-normal">Casing coordinates</th>
                                    <td className="col-4 px-[24px] py-[16px]">
                                        <div className="pb-4 secondary">
                                            Commonly used by all above cable clearance chart
                                        </div>
                                        <div className="">
                                            <p className="secondary-text">
                                                To fetch coordinates it will loop through 200 iteration<br />
                                            </p>
                                            <p className="secondary">if iteration equals to 1 :</p>
                                            <p className="secondary-text">
                                                CasingXvalue = -(casingID /2)<br />
                                                CasingYvalue = (((casingID/2)^2) - (CasingXvalue^2))^0.5
                                            </p>
                                            <p className="secondary"> if iteration not equals to 1 & iteration is less than
                                                101 :</p>
                                            <p className="secondary-text">
                                                CasingXvalue = CasingXvalue + CasingStart<br />
                                                CasingYvalue = (((casingID/2)^2) - (CasingXvalue^2))^0.5
                                            </p>
                                            <p className="secondary"> if iteration equal to 101 :</p>
                                            <p className="secondary-text">
                                                CasingXvalue = CasingXvalue + CasingStart<br />
                                                CasingYvalue = (Absolute((casingID / 2) ^ 2) - (CasingXvalue ^ 2))^0.5
                                            </p>
                                            <p className="secondary"> Otherwise :</p>
                                            <p className="secondary-text">
                                                CasingXvalue = CasingXvalue - CasingStart<br />
                                                CasingYvalue = -(((casingID / 2) ^ 2) - (CasingXvalue ^ 2)) ^ 0.5
                                            </p>
                                            <p className="secondary"> CasingStart :</p>
                                            <p className="secondary-text">
                                                (casingID/100)
                                            </p>
                                            <p className="secondary">casingID :</p>
                                            <p className="secondary-text">
                                                Selected casingID from ESP catalog (DR_CasingSize table in database)
                                            </p>
                                        </div>
                                    </td>
                                    <td className="col-4 px-[24px] py-[16px]"></td>
                                    <td className="col-4 px-[24px] py-[16px]"></td>
                                </tr>
                            </table>
                        </div>
                    </div>
                }
            ></Accordion>
            <Accordion
                title={LABELS?.surfaceVoltage}
                id={'SurfaceVolt'}
                isOpen={!surfaceVoltCollapse}
                onToggle={() =>
                    handleCollapseChange(!surfaceVoltCollapse, "SurfaceVolt")
                }
                content={
                    <div className="flex justify-center items-center bg-darkcolor-800 p-[16px] w-full rounded-br-lg rounded-bl-lg">
                        <div className='pad-all w-full bg-darkcolor-700 border-[1px] border-darkcolor-400 rounded-lg'>
                            <table className="table table-striped table-bordered dtr-inline">
                                <colgroup>
                                    <col style={{ width: "10%" }} />
                                    <col style={{ width: "40%", borderRight: "1px solid #4a5463" }} />
                                    <col style={{ width: "10%" }} />
                                    <col style={{ width: "40%" }} />
                                </colgroup>
                                <tr className="border-b-[1px] border-darkcolor-400 align-center text-[14px] font-normal">
                                    <th className="col-1 px-[24px] py-[16px] align-center font-normal">Total cable length</th>
                                    <td className="col-5 px-[24px] py-[16px]">
                                        <div className="pb-4 secondary">
                                            PumpSetting@MeasuredDepth + SurfaceCableLength
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">PumpSetting@MeasuredDepth :</p>
                                            <p className="secondary-text">
                                                Well tab
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">SurfaceCableLength :</p>
                                            <p className="secondary-text">
                                                Cable tab
                                            </p>
                                        </div>
                                        <div className="">
                                            <p className="secondary">Metric conversion :</p>
                                            <p className="secondary-text">
                                                PumpSetting@MeasuredDepth * 3.28084<br />
                                                SurfaceCableLength * 3.28084
                                            </p>
                                        </div>
                                    </td>
                                    <th className="col-1 px-[24px] py-[16px] align-center font-normal">Cable volt loss/1000</th>
                                    <td colSpan={3} className="col-5 auto-va px-[24px] py-[16px]">
                                        <div className="pb-4 secondary">
                                            (( v0 + (v1 * NamePlatecurrent) + (v2 * NamePlatecurrent^2) + (v3 * NamePlatecurrent^3) +(v4 * NamePlatecurrent^4) + (v5 * NamePlatecurrent^5)) * TempCorrectFactor )
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">[v0, v1, v2, v3, v4, v5] :</p>
                                            <p className="secondary-text">
                                                Selected cable coefficient from ESP catalog (DR_Cables table in database)
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">NamePlatecurrent :</p>
                                            <p className="secondary-text">
                                                Selected motor current from ESP catalog (Dr_Motors table in database)
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">TempCorrectFactor :</p>
                                            <p className="secondary-text">
                                                0.002134629 * BottomHoleTemp + 0.836357091
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">BottomHoleTemp :</p>
                                            <p className="secondary-text">
                                                Fluid input tab
                                            </p>
                                        </div>
                                        <div className="">
                                            <p className="secondary">Metric conversion :</p>
                                            <p className="secondary-text">
                                                bottomHoleTemp * (9 / 5) + 32<br />
                                                Cable volt loss/1000 * 3.28084
                                            </p>
                                        </div>
                                    </td>
                                </tr>
                                <tr className="border-b-[1px] border-darkcolor-400 align-center text-[14px] font-normal">
                                    <th className="col-1 px-[24px] py-[16px] align-center font-normal">% V.Drop / Nm Plate motor volt </th>
                                    <td className="col-5 px-[24px] py-[16px]">
                                        <div className="pb-4 secondary">
                                            (TotalCableVoltLoss / SelectedMotorVolts) * 100
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">TotalCableVoltLoss :</p>
                                            <p className="secondary-text">
                                                Cable tab surface voltage section
                                            </p>
                                        </div>
                                        <div className="">
                                            <p className="secondary">SelectedMotorVolts :</p>
                                            <p className="secondary-text">
                                                Motor tab selected motor volts
                                            </p>
                                        </div>
                                    </td>
                                    <th className="col-1 px-[24px] py-[16px] align-center font-normal">Total cable volt loss </th>
                                    <td className="col-5 px-[24px] py-[16px]">
                                        <div className="pb-4 secondary">
                                            CableVoltLossPer1000 * (TotalCableLength / 1000)
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">CableVoltLossPer1000 :</p>
                                            <p className="secondary-text">
                                                Cable volt loss/1000 from cable tab surface voltage section
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">TotalCableLength :
                                                <br />If 'Cable length override' is available
                                            </p>
                                            <p className="secondary-text">
                                                Total cable length from cable tab surface voltage section
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">If 'Cable length override' is not available </p><br />
                                            <p className="secondary-text">
                                                'Pump setting @ measured depth'(From well tab) + 'Surface cable length'(from
                                                cable tab surface voltage section)

                                            </p>
                                        </div>
                                        <div className="">
                                            <p className="secondary">Metric conversion :</p>
                                            <p className="secondary-text">
                                                CableVoltLossPer1000 * 3.28084
                                            </p>
                                        </div>
                                    </td>
                                </tr>
                                <tr className="border-b-[1px] border-darkcolor-400 align-center text-[14px] font-normal">
                                    <th className="col-1 px-[24px] py-[16px] align-center font-normal">Ampacity</th>
                                    <td className="col-5 px-[24px] py-[16px]">
                                        <div className="pb-4 secondary">
                                            ((CableTempRating - bottomHoleTemp) / CorrectionFactor)^0.5
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">CableTempRating :</p>
                                            <p className="secondary-text">
                                                Selected TempRating_F from ESP catalog (Dr_Cables table in database)
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">CorrectionFactor :</p>
                                            <p className="secondary-text">
                                                Selected TempCorrectionfactor from ESP catalog (Dr_Cables table in database)
                                            </p>
                                        </div>
                                        <div className="">
                                            <p className="secondary">Metric conversion :</p>
                                            <p className="secondary-text">
                                                bottomHoleTemp * (9 / (double)5) + 32
                                            </p>
                                        </div>
                                    </td>
                                    <th className="col-1 px-[24px] py-[16px] align-center font-normal">Surface volt @ operating frequency </th>
                                    <td colSpan={3} className="col-5 auto-va px-[24px] py-[16px]">
                                        <div className="pb-4 secondary">
                                            VoltageMotor + VoltDrop
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">VoltDrop :</p>
                                            <p className="secondary-text">
                                                Total cable volt loss from cable tab
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">VoltageMotor :</p>
                                            <p className="secondary-text">
                                                (NamePlatevoltage * frequency/60)
                                            </p>
                                        </div>
                                        <div className="">
                                            <p className="secondary">NamePlatevoltage :</p>
                                            <p className="secondary-text">
                                                Selected motor voltage from ESP catalog (Dr_Motors table in database)
                                            </p>
                                        </div>
                                    </td>
                                </tr>
                                <tr className="align-center text-[14px] font-normal">
                                    <th className="col-1 px-[24px] py-[16px] align-center font-normal">Max conductor temperature</th>
                                    <td className="col-5 px-[24px] py-[16px]">
                                        <div className="pb-4 secondary">
                                            CorrectionFactor * NamePlatecurrent ^2 + bottomHoleTemp
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">Correction factor :</p>
                                            <p className="secondary-text">
                                                Selected TempCorrectionfactor from ESP catalog (Dr_Cables table in database)
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">NamePlatecurrent :</p>
                                            <p className="secondary-text">
                                                Selected motor current from ESP catalog (Dr_Motors table in database)
                                            </p>
                                        </div>
                                        <div className="">
                                            <p className="secondary">Metric Conversion :</p>
                                            <p className="secondary-text">
                                                bottomHoleTemp * (9 / (double)5) + 32<br />
                                                (MaxConductorTemperature- 32) * (5/9)
                                            </p>
                                        </div>
                                    </td>
                                    <th className="col-1 px-[24px] py-[16px] align-center font-normal">Conductor temperature @ operating frequency</th>
                                    <td colSpan={3} className="col-5 auto-va px-[24px] py-[16px]">
                                        <div className="pb-4 secondary">
                                            CorrectionFactor * MotorPerformaceCurrent ^2 + bottomHoleTemp
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">MotorPerformaceCurrent :</p>
                                            <p className="secondary-text">
                                                current * NamePlatecurrent
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">NamePlatecurrent :</p>
                                            <p className="secondary-text">
                                                Selected motor current from ESP catalog (Dr_Motors table in database)
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary"> current :</p>
                                            <p className="secondary-text">
                                                C0 + C1 * PUHP + C2 * PUHP^2 + C3 * PUHP^3 + C4 * PUHP^4 + C5 * PUHP^5
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">[C0, C1, C2, C3, C4, C5] :</p>
                                            <p className="secondary-text">
                                                Selected motor coefficient from ESP catalog (Dr_Motors table in database)
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">PUHP :</p>
                                            <p className="secondary-text">
                                                (TotalBHP / motorHP)
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">motorHP :</p>
                                            <p className="secondary-text">
                                                (size * frequency / 60)
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">size :</p>
                                            <p className="secondary-text">
                                                Selected motor size from ESP catalog (Dr_Motors table in database)
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">TotalBHP :</p>
                                            <p className="secondary-text">
                                                Total power required @ opearting frequency - Motor tab
                                            </p>
                                        </div>
                                        <div className="">
                                            <p className="secondary">Metric conversion :</p>
                                            <p className="secondary-text">
                                                bottomHoleTemp * (9 / (double)5) + 32<br />
                                                motorHP * 0.7457<br />
                                                TotalBHP * 0.7457<br />
                                                (Conductor Temperature@DesignFrquency - 32) * (5/9)
                                            </p>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                }
            />
        </div>
    );
};

export default Cable;
